module.exports = __webpack_public_path__ + "static/img/automotive-service-advisor.fbeec9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/automotive-service-advisor.png
// module id = TDfB
// module chunks = 0